// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/airspeed-in-turns.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/airspeed-in-turns/airspeed-in-turns.js';

mount([g0]);
